import {EntityData, field, identifier} from "../entity/entity.data";

/**
 * Defines a saved report and its parameters
 */
export class SavedReportData extends EntityData<SavedReportData> {
    @identifier id: number;
    @field name: string;
    @field params: any;
}
